module.exports = __webpack_public_path__ + "img/sanduiche.0e28e9d6.svg";